import Immutable from 'immutable';

export const imageMimeTypes = new Set([
  'image/bmp',
  'image/jpeg',
  'image/svg+xml',
  'image/gif',
  'image/png',
]);

export const fileExtensionRegex = /(?:\.([^.]+))?$/;

export const imageFileExtensions = Immutable.Set([
  'ai',
  'bmp',
  'dib',
  'eps',
  'gif',
  'heic',
  'heif',
  'ind',
  'indd',
  'indt',
  'j2k',
  'jfi',
  'jfif',
  'jif',
  'jp2',
  'jpe',
  'jpeg',
  'jpf',
  'jpg',
  'jpm',
  'jpx',
  'mj2',
  'png',
  'psd',
  'svg',
  'svgz',
  'tif',
  'tiff',
  'webp',
]);
